import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { cx } from '@emotion/css';
import styled from '@emotion/styled';

import { Price } from '@common/components';
import { Typography } from '@common/styles';

import { LegacyRow as Row } from '../layouts/LegacyRow';

interface Props {
  discountText?: string;
  label: string;
  price: number;
  priceColor?: string;
}

export const PriceTotalRow: React.FC<React.PropsWithChildren<Props>> = ({ discountText, label, price, priceColor }) => {
  return (
    <StyledRow>
      <Label className={Typography.BODY_15_SEMIBOLD}>{label}</Label>
      <PriceBadgeWrapper>
        {Boolean(discountText) && (
          <DiscountTitle className={Typography.BODY_13_MEDIUM} color={priceColor}>
            {discountText}
          </DiscountTitle>
        )}
        <Price className={cx('price', Typography.HEAD_20_BOLD)} price={price} color={priceColor} />
      </PriceBadgeWrapper>
    </StyledRow>
  );
};

const StyledRow = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;

  .price {
    letter-spacing: 0;
  }
`;

const Label = styled.span`
  color: ${vars.v3Color.gray900};
`;

const PriceBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const DiscountTitle = styled.div<{ color?: string }>`
  margin: 0 4px 0 0;
  position: relative;
  top: 1px;
  ${({ color }) => color && `color: ${color}`};
`;
